<template>
  <section class="section container">
    <div class="box">
      <h1 class="title">ประวัติการสนับสนุน</h1>
      <b-field v-show="isAdmin">
        <b-input type="text is-primary" v-model="search" placeholder="Search here!"></b-input>
        <b-input type="text is-primary" v-model="uid" placeholder="UID here!"></b-input>
        <button class="button is-primary" @click="refresh">Search!</button>
      </b-field>
      <b-table :data="paymentsWithDetail"
      paginated
      hoverable
      per-page="20"
      :current-page.sync="currentPage"
      default-sort="date"
      default-sort-direction="desc"
      :loading="isLoading"
      detailed
      detail-key="id"
      >
        <template slot-scope="props">
          <b-table-column>
              <p class="button is-danger"
                @click="confirmDeletePayment(props.row)"
                v-show="props.row.status !== 'completed' || isAdmin"
                :class="{ 'is-loading': deleting === props.row.id }" >ลบ</p>
          </b-table-column>
          <b-table-column field="id" label="หมายเลขอ้างอิง" centered numeric sortable>
              {{  props.row.id}}
          </b-table-column>

          <b-table-column field="status" label="สถานะ" centered numeric sortable>
            <button class="tag" :class="classForStatus(props.row.status)" @click="changeStatus(props.row)">{{ paymentStatus(props.row.status) }}</button>
          </b-table-column>

          <b-table-column field="novel" label="นิยายเรื่อง" centered>
            <div class="content">
              <button class="tag" @click="changeNovel(props.row)"><p>{{ props.row.novel.name }}</p></button>
            </div>
          </b-table-column>

          <b-table-column field="level" label="ระดับ" centered>
            <div class="content">
              <p>{{ props.row.subscription ? props.row.subscription.name : 'Rank F' }}</p>
            </div>
          </b-table-column>

          <b-table-column label="Email/UID" centered :visible="isAdmin">
            <button class="tag" @click="changeEmail(props.row)" v-show="props.row['user_email']">{{ props.row['user_email'] }}</button>
            <button class="tag" @click="changeUID(props.row)">UID: {{ props.row['uid'] ? props.row['uid'] : '' }}</button>
          </b-table-column>

          <b-table-column field="amount" label="จำนวนเงิน">
            <button class="tag" @click="changeAmount(props.row)">{{ props.row.amount }} ฿</button>
          </b-table-column>

          <b-table-column field="date" label="วันที่/เวลา" sortable>
            <span class="tag is-success">
                {{ props.row.date !== undefined ? dateFormatted(props.row.date) : '' }}
            </span>
          </b-table-column>
        </template>

        <template slot="detail" slot-scope="props">
          <payment-detail :payment="props.row" :novel="props.row.novel" :subscription="props.row.subscription" hasContact></payment-detail>
        </template>
        <template slot="empty">
            <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <div v-if="isLoading">
                    <p>Loading...</p>
                  </div>
                  <div v-else>
                    <p><i class="far fa-sad-tear"></i></p>
                    <p>No payments history on accounts: {{ this.user.email }}</p>
                  </div>
                </div>
            </section>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import { get } from 'vuex-pathify'
import { db, storage } from '@/firebase.config'
const PaymentDetail = () => import(/* webpackChunkName: "payment_detail" */ '@/components/PaymentDetail')

export default {
  name: 'payments',
  components: {
    PaymentDetail
  },
  metaInfo () {
    return {
      title: 'ประวัติการสนับสนุน',
      meta: [
        { property: 'og:title', content: 'ประวัติการสนับสนุนของท่าน' },
        { property: 'og:description', content: 'จำเป็นต้องเข้าสู่ระบบก่อนเพื่อตรวจสอบประวัติการสนับสนุนของท่าน' },
        { property: 'og:image', content: 'https://www.secretentourage.com/wp-content/uploads/2017/03/tumblr_n7dag0p3S51tdu5aqo1_1280.jpg' },
        { property: 'og:url', content: this.$route.fullPath }
      ]
    }
  },
  data () {
    return {
      novels: this.$root.novels,
      payments: [],
      currentPage: 1,
      isLoading: true,
      deleting: '',
      search: '',
      uid: ''
    }
  },
  mounted () {
    this.refresh()
  },
  computed: {
    paymentFilteredDatabase () {
      if (this.isAdmin) {
        var query = db.collection('payments')
        if (this.search && this.uid) {
          return query.where('user_email', '==', this.search).where('uid', '==', this.uid)
        } else if (this.search) {
          return query.where('user_email', '==', this.search)
        } else if (this.uid) {
          return query.where('uid', '==', this.uid)
        }
        return query.orderBy('date', 'desc').limit(20)
      }
      return db.collection('payments').where('user_email', '==', this.user.email).orderBy('date')
    },
    user: get('user'),
    isAdmin: get('isAdmin'),
    paymentsWithDetail () {
      if (this.payments.length === 0) { return [] }
      if (this.novels.length === 0) { return [] }
      return this.payments
        .map(payment => {
          var novelId = payment['novel_id']
          var subscriptionId = payment['subscription_plan_id']
          if (novelId === undefined) {
            novelId = 'xian-ni'
          }
          if (!subscriptionId) {
            subscriptionId = payment.amount
          }
          payment.novel = this.novels.find(novel => novel.id === novelId)
          if (payment.novel.subscriptions) {
            payment.subscription = payment.novel.subscriptions.find(value => value.id === subscriptionId)
          }
          if (payment.novel.subscriptions && !payment.subscription) {
            payment.subscription = payment.novel.subscriptions.find(value => value.price === payment.amount)
          }
          return payment
        })
    }
  },
  methods: {
    addTransaction (payment) {
      this.$ga.ecommerce.addTransaction({
        id: payment.id,
        affiliation: payment.subscription.id,
        revenue: payment.amount
      })
      this.$ga.ecommerce.addItem({
        id: payment.id,
        name: payment.subscription.name,
        sku: payment['subscription_plan_id'],
        category: payment['novel_id'],
        price: payment.amount,
        quantity: '1'
      })
      this.$ga.ecommerce.send()
    },
    confirmDeletePayment (row) {
      this.$root.$dialog.confirm({
        title: 'ยืนยันการลบ',
        message: 'การลบนี้จะไม่สามารถกู้คืนกลับมาได้ ต้องการยืนยันหรือไม่',
        confirmText: 'ยืนยัน',
        cancelText: 'ยกเลิก',
        onConfirm: () => this.deletePayment(row)
      })
    },
    deletePayment (payment) {
      this.deleting = payment.id
      db.collection('payments').doc(payment.id)
        .delete()
        .then(() => {
          this.deleting = ''
          this.$toast.open({ message: 'Payment successfully deleted!' })
          this.refresh()
        })
        .catch(error => {
          this.deleting = ''
          this.$toast.open({ message: `Error removing payment: ${error.code}` })
          this.refresh()
        })
      storage.child('payments/images/' + payment.id)
        .delete()
        .then(() => {
          this.deleting = ''
          this.$toast.open({ message: 'Payment deleted images successfull!' })
          this.refresh()
        })
        .catch(error => {
          this.deleting = ''
          if (error.code !== 'storage/object-not-found') {
            this.$toast.open({ message: `Error removing image: ${error.code}` })
          }
          this.refresh()
        })
    },
    updatePayment (payment, status) {
      if (status.status && status.status === 'completed') {
        this.addTransaction(payment)
      }
      db.collection('payments').doc(payment.id)
        .update({ ...status })
        .then(() => {
          this.$toast.open({ message: 'Document successfully updated!' })
          this.refresh()
        })
        .catch(error => {
          this.$toast.open({ message: `Error updating document: ${error.code}` })
          this.refresh()
        })
    },
    changeAmount (payment) {
      if (!this.isAdmin) { return }
      this.$dialog.prompt({
        message: `Payment id ${payment.id} <br><b>User</b>: ${payment['user_email']}`,
        inputAttrs: {
          type: 'number',
          value: payment.amount
        },
        onConfirm: (value) => this.updatePayment(payment, { amount: value })
      })
    },
    changeEmail (payment) {
      if (!this.isAdmin) { return }
      this.$dialog.prompt({
        message: `Payment id ${payment.id} <br><b>User</b>: ${payment['user_email']}`,
        inputAttrs: {
          type: 'text',
          value: payment['user_email']
        },
        onConfirm: (value) => this.updatePayment(payment, { 'user_email': value })
      })
    },
    changeNovel (payment) {
      if (!this.isAdmin) { return }
      this.$dialog.prompt({
        message: `<datalist id="novel_list">
                    <option value="solo-leveling">Solo Leveling
                    <option value="xian-ni">Xian Ni
                  </datalist>
                  Novel id ${payment.novel_id}`,
        inputAttrs: {
          type: 'text',
          placeholder: payment['novel_id'],
          list: 'novel_list'
        },
        onConfirm: (value) => this.updatePayment(payment, { 'novel_id': value })
      })
    },
    changeUID (payment) {
      if (!this.isAdmin) { return }
      this.$dialog.prompt({
        message: `Payment id ${payment.id} <br><b>UID</b>: ${payment['uid']}`,
        inputAttrs: {
          type: 'text',
          value: payment['uid'] ? payment['uid'] : ''
        },
        onConfirm: (value) => this.updatePayment(payment, { 'uid': value })
      })
    },
    changeStatus (payment) {
      if (!this.isAdmin) { return }
      this.$dialog.prompt({
        message: `<datalist id="change_status">
                    <option value="completed">Completed
                    <option value="pending">Pending
                    <option value="refunded">Refunded
                    <option value="waiting_transfer">Waiting Transfer
                  </datalist>
                Payment: ${payment.id} <br><b>User</b>: ${payment['user_email']}`,
        inputAttrs: {
          type: 'text',
          placeholder: payment.status,
          list: 'change_status'
        },
        onConfirm: (value) => {
          if (value === 'C' || value === 'c') {
            this.updatePayment(payment, { status: 'completed' })
          } else {
            this.updatePayment(payment, { status: value })
          }
        }
      })
    },
    classForStatus (status) {
      if (status === 'completed') {
        return 'is-success'
      }
      if (status === 'refunded') {
        return 'is-danger'
      }
      if (status === 'pending') {
        return 'is-info'
      }
      if (status === 'waiting_transfer') {
        return 'is-warning'
      }
    },
    dateFormatted (date) {
      var options = { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }
      return date.toDate().toLocaleDateString('en-GB', options)
    },
    paymentStatus (status) {
      switch (status) {
        case 'waiting_transfer': return 'ขาดหลักฐานชำระเงิน'
        case 'refunded': return 'ยกเลิกรายการ'
        case 'completed': return 'เสร็จสมบูรณ์'
        default: return 'รออนุมัติ'
      }
    },
    refresh () {
      this.isLoading = true
      this.paymentFilteredDatabase
        .get()
        .then((collection) => {
          this.isLoading = false
          if (collection.size > 0) {
            this.payments = collection.docs.map(doc => ({ ...doc.data(), 'id': doc.id }))
          } else {
            console.log('No payments history on accounts: ', this.user.email)
          }
        })
        .catch(error => {
          this.isLoading = false
          console.log('Error getting documents: ', error)
        })
    }
  }
}
</script>

<style lang="scss">

</style>
